import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchInputForm } from 'src/components/common/form/search/SearchInputForm';
import { SysCodeDto } from 'src/dtos/code/sysCodeDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';

import useSYS2010_R01Store from './Store_SYS2010_R01';

interface Props {
	onEnterKeyDown: () => void;
}

export const SearchSection_SYS2010_R01 = ({ onEnterKeyDown }: Props) => {
	const { SYS2010_R01Filter, setSYS2010_R01Filter } = useSYS2010_R01Store();
	const { systemList, yesNoList, devStsList } = useCommonCodeStore();

	const expandSearch = () => (
		<>
			<SearchInputForm
				label="업무시스템(타이핑)"
				value={SYS2010_R01Filter.menuCd}
				onChange={(e) => setSYS2010_R01Filter({ menuCd: e.target.value.toUpperCase() })}
				onKeyDown={(e) => e.key === 'Enter' && onEnterKeyDown()}
				initValue={() => {}}
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[110px] min-w-[110px]',
					inputStyle: 'w-[180px] min-w-[180px] border border-gray-300 px-[6px] h-[24px] rounded-[6px]',
				}}
			/>
			<SearchInputForm
				label="업무시스템명"
				value={SYS2010_R01Filter.menuNm}
				onChange={(e) => setSYS2010_R01Filter({ menuNm: e.target.value })}
				onKeyDown={(e) => e.key === 'Enter' && onEnterKeyDown()}
				initValue={() => setSYS2010_R01Filter({ menuNm: '' })}
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]',
				}}
			/>
		</>
	);

	return (
		<SearchSectionForm expandSearch={expandSearch}>
			<SearchDropDownForm<SysCodeDto>
				label="업무시스템"
				value={SYS2010_R01Filter.menuCd}
				optionList={systemList}
				onChangeValue={(v) => setSYS2010_R01Filter({ menuCd: v === 'all' ? '' : v })}
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[60px] min-w-[60px]',
					selectStyle: 'w-[100px] min-w-[90px] border border-gray-300 px-[6px] h-[24px] rounded-[6px]',
				}}
			/>
			<SearchDropDownForm<SysCodeDto>
				label="사용여부"
				value={SYS2010_R01Filter.useYn}
				optionList={yesNoList}
				onChangeValue={(v) => setSYS2010_R01Filter({ useYn: v === 'all' ? '' : v })}
			/>
			<SearchDropDownForm<SysCodeDto>
				label="개발상태"
				value={SYS2010_R01Filter.devSts}
				optionList={devStsList}
				onChangeValue={(v) => setSYS2010_R01Filter({ devSts: v === 'all' ? '' : v })}
			/>
		</SearchSectionForm>
	);
};
